@import '~/src/common/colors';

.input {
    display: inline-block;
    font-size: 16px;

    padding: 3px 5px;
    margin: 5px;

    border-color: $gray;
    border-style: solid;
    border-width: 1px;
    border-radius: 5px;

    text-rendering: auto;
    text-align: start;
    color: initial;
    background: #fff;

    transition: .3s;
    cursor: pointer;

    &:hover {
        filter: brightness(0.9);
    }

    &:focus-visible {
        box-shadow: 0 0 0 4px #a6bdee;
    }
}